export default __webpack_public_path__ + "static/media/favicon.b581dab7.ico";